import axiosInstance from "../api/axiosInstance";
// GET list with pagination and search
export const getTochlistadmin = (params) => axiosInstance.get("/admin/getTochlistadmin", { params });
